<kendo-grid [data]="codeLanguageGrid.gridData" [loading]="codeLanguageGrid.loading" [navigable]="true"
    [pageable]="codeLanguageCount > codeLanguageGrid.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
    [skip]="codeLanguageGrid.state.skip" [pageSize]="codeLanguageGrid.state.take" [sortable]="true"
    [sort]="codeLanguageGrid.state.sort" [filterable]="codeGridAdvanced" [filter]="codeLanguageGrid.state.filter"
    [columnMenu]="codeGridAdvanced" [resizable]="true" [reorderable]="codeGridAdvanced"
    (dataStateChange)="codeLanguageGrid.setState($event)" (add)="codeLanguageAddHandler($event)"
    (edit)="codeLanguageEditHandler($event)" (save)="saveCodeLanguage($event)"
    (cancel)="codeLanguageGrid.cancelHandler($event)">
    <kendo-grid-messages noRecords="{{ 'NO-LANGUAGES' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column field="displayName" title="{{'DISPLAY-NAME' | translate}}" [width]="50">
    </kendo-grid-column>
    <kendo-grid-column field="language" title="{{'LANGUAGE' | translate}}" [width]="25">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div>{{ dataItem.language.displayName }}</div>
        </ng-template>
        <ng-template *ngIf="isNew" kendoGridEditTemplate let-dataItem="dataItem" let-column="column"
            let-formGroup="formGroup">
            <kendo-combobox [data]="languagesFiltered" [textField]="'displayName'" [valueField]="'id'"
                [filterable]="true" (filterChange)="filterLanguages($event)" (close)="searchTerm=''"
                [formControl]="formGroup.get('language')" [virtual]="virtualLanguage">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                    </span>
                </ng-template>
            </kendo-combobox>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column [width]="15" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
            <ng-container *ngIf="!dataItem.editing">
                <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                    (click)="codeLanguageEditButton.click.emit($event); dataItem.editing = true;"></i>
                &nbsp;
                <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                    (click)="openDeleteCodeLanguageDialog(dataItem)"></i>
                <button kendoGridEditCommand #codeLanguageEditButton class="d-none"></button>
            </ng-container>
            <ng-container *ngIf="dataItem.editing">
                <ng-container *ngIf="codeLanguageFormGroup.valid">
                    <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="codeLanguageSaveButton.click.emit($event); dataItem.editing = false;">
                    </i>
                    &nbsp;
                </ng-container>
                <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                    (click)="codeLanguageCancelButton.click.emit($event); dataItem.editing = false;"></i>
                <button kendoGridSaveCommand #codeLanguageSaveButton class="d-none"></button>
                <button kendoGridCancelCommand #codeLanguageCancelButton class="d-none"></button>
            </ng-container>
        </ng-template>
    </kendo-grid-command-column>
    <button kendoGridAddCommand #codeLanguageAddButton class="d-none"></button>
</kendo-grid>
<button kendoButton type="button" class="float-right mt-3 mb-3" (click)="codeLanguageAddButton.click.emit($event)">
    {{'ADD' | translate}}<i class="far fa-plus"></i>
</button>

<!-- delete code set confirmation dialog -->
<kendo-dialog *ngIf="codeLanguageDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="codeLanguageDeleteDialogOpened = false">
    <p>{{'CONFIRM-CODE-LANGUAGE-DELETION' | translate}}</p>
    <div>
        <span
            class="k-font-weight-bold">{{selectedCodeLanguageGrid.displayName}}&nbsp;-&nbsp;{{selectedCodeLanguageGrid.language.displayName}}</span>
    </div>
    <div *ngIf="errorMessage" class="text-danger k-tooltip-validation" role="alert">
        {{errorMessage}}
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="codeLanguageDeleteDialogOpened = false">{{'NO' | translate}}</button>
        <button kendoButton (click)="deleteCodeLanguage(selectedCodeLanguageGrid)" [disabled]="errorMessage">{{'YES' |
            translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>